export default __webpack_public_path__ + "static/media/warning--t-roads--g1.02138011.png";